import { useState } from 'react';
type Props = { value: number | 'all'; onChange: (value: number | 'all') => void };
export function OsrGenerationOptions({ value, onChange }: Props) {
  const [custom, setCustom] = useState(typeof value === 'number' && value !== 1 && value !== 3);
  return <div className="space-y-3">
    <div className="flex flex-wrap gap-2">
      {([1, 3, 'custom', 'all'] as const).map((option) => (
        <button key={option} type="button"
          aria-pressed={option === 'custom' ? custom : !custom && value === option}
          onClick={() => { setCustom(option === 'custom'); onChange(option === 'custom' ? 5 : option); }}
          className="rounded-full border border-border px-4 py-2 text-sm aria-pressed:border-primary aria-pressed:bg-blue-50">
          {option === 'all' ? '全部自动安排' : option === 'custom' ? '自定义' : `${option} 组`}
        </button>
      ))}
    </div>
    {custom && typeof value === 'number' ? <label className="flex items-center gap-2 text-sm">
      自定义组数<input aria-label="自定义组数" type="number" min={1} max={100} value={value}
        onChange={(event) => onChange(Math.min(100, Math.max(1, Number(event.target.value) || 1)))}
        className="w-24 rounded border border-border px-2 py-1" />
    </label> : null}
    <p className="text-xs leading-relaxed text-muted">每组以一份素材为参考，围绕关键能力生成必要台阶，张数由内容决定。全部自动安排会将当前学科素材提交后台，提交完成后可关闭页面。</p>
  </div>;
}
